import { render, staticRenderFns } from "./UserReviewRecordsDetail.vue?vue&type=template&id=e814d0d4&"
import script from "./UserReviewRecordsDetail.vue?vue&type=script&lang=js&"
export * from "./UserReviewRecordsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports